import styled from "styled-components";
import {MOBILE_SAFARI_AND_CHROME_ONLY, SHARED_ICONS, SHARED_ICONS_LIST, WhatsAppIcon} from "./SharedIcons";
import {FC, ReactNode, useMemo} from "react";
import {SharedIconListProps} from "./SharedIconList";
import {getWindowParams} from "../actions/getWindowParams";
import {LayoutConst} from "../../../../core";
import {browserName} from "../../../helpers/currentBrowser";
import {Colors, useIsMobile, useToasts} from "@brg/ui";
import {useTranslation} from "react-i18next";


const ShareIconText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.galBlack73};

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 3.3vw;
    line-height: 4.1vw;
  }
`

const IconPicWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  min-width: 40px;
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: 10vw;
    min-width: 10vw;
  }
`

const ShareIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  cursor: pointer;
  align-items: center;
  width: fit-content;
  //min-width: 72px;

  &:hover ${ShareIconText} {
    color: #545453;
  }

  &:hover ${IconPicWrapper} {
    svg {
      path {
        fill: ${Colors.galBlack73};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    //min-width: 72px;
    min-width: 18.5vw;

    svg {
      width: 10vw;
      height: 10vw;
      path {
        fill: ${Colors.galBlack73};
      }
    }
    /*    &:first-child {
          min-width: 55px;
          align-items: flex-start;
        }
        &:last-child {
          min-width: 55px;
          align-items: flex-end;
        }*/
  }
`

interface ShareIconItem {
    title: string;
    icon: ReactNode;
    link: string;
}

export const ShareIconItem: FC<ShareIconItem> = ({title, icon, link}) => {

    const isMobile = useIsMobile();
    const {error} = useToasts();
    const {t} = useTranslation();
    const isLocked = useMemo(() => {
        if (browserName() === 'Google Chrome' || browserName() === 'Apple Safari' || !isMobile) return false;

        return MOBILE_SAFARI_AND_CHROME_ONLY.includes(title as SHARED_ICONS)
    }, [title, isMobile])

    return <ShareIconWrapper onClick={
        () => isLocked ? error(t('sharing.safari_chrome_only_error')) : window.open(link, "_blank", getWindowParams())}>
        <IconPicWrapper>{icon}</IconPicWrapper>
        <ShareIconText>{title}</ShareIconText>
    </ShareIconWrapper>
}import styled from "styled-components";
import {MOBILE_SAFARI_AND_CHROME_ONLY, SHARED_ICONS, SHARED_ICONS_LIST, WhatsAppIcon} from "./SharedIcons";
import {FC, ReactNode, useMemo} from "react";
import {SharedIconListProps} from "./SharedIconList";
import {getWindowParams} from "../actions/getWindowParams";
import {LayoutConst} from "../../../../core";
import {browserName} from "../../../helpers/currentBrowser";
import {Colors, useIsMobile, useToasts} from "@brg/ui";
import {useTranslation} from "react-i18next";


const ShareIconText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.galBlack73};

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 3.3vw;
    line-height: 4.1vw;
  }
`

const IconPicWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  min-width: 40px;
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: 10vw;
    min-width: 10vw;
  }
`

const ShareIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  cursor: pointer;
  align-items: center;
  width: fit-content;
  //min-width: 72px;

  &:hover ${ShareIconText} {
    color: #545453;
  }

  &:hover ${IconPicWrapper} {
    svg {
      path {
        fill: ${Colors.galBlack73};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    //min-width: 72px;
    min-width: 18.5vw;

    svg {
      width: 10vw;
      height: 10vw;
      path {
        fill: ${Colors.galBlack73};
      }
    }
    /*    &:first-child {
          min-width: 55px;
          align-items: flex-start;
        }
        &:last-child {
          min-width: 55px;
          align-items: flex-end;
        }*/
  }
`

interface ShareIconItem {
    title: string;
    icon: ReactNode;
    link: string;
}

export const ShareIconItem: FC<ShareIconItem> = ({title, icon, link}) => {

    const isMobile = useIsMobile();
    const {error} = useToasts();
    const {t} = useTranslation();
    const isLocked = useMemo(() => {
        if (browserName() === 'Google Chrome' || browserName() === 'Apple Safari' || !isMobile) return false;

        return MOBILE_SAFARI_AND_CHROME_ONLY.includes(title as SHARED_ICONS)
    }, [title, isMobile])

    return <ShareIconWrapper onClick={
        () => isLocked ? error(t('sharing.safari_chrome_only_error')) : window.open(link, "_blank", getWindowParams())}>
        <IconPicWrapper>{icon}</IconPicWrapper>
        <ShareIconText>{title}</ShareIconText>
    </ShareIconWrapper>
}